import { createTheme } from "@mui/material/styles";

// Tema escuro MUI alinhado com o visual do sistema (fundo #1e1e1e, texto branco, azul primário)
const muiTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#2196f3",
      dark: "#0056b3",
      contrastText: "#fff",
    },
    error: {
      main: "#e53935",
    },
    warning: {
      main: "#f59e0b",
    },
    success: {
      main: "#22c55e",
    },
    background: {
      default: "#1e1e1e",
      paper: "#2c2c2c",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255,255,255,0.7)",
    },
    divider: "#444",
  },
  typography: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#1e1e1e",
          color: "#ffffff",
          fontWeight: 600,
        },
        body: {
          color: "#ffffff",
          borderBottomColor: "#444",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "rgba(255,255,255,0.04)" },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": { borderColor: "#555" },
          "&:hover fieldset": { borderColor: "#888" },
        },
        input: { color: "#fff" },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { color: "rgba(255,255,255,0.7)" },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 500 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundColor: "#2c2c2c" },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: { color: "#fff", borderTop: "1px solid #444" },
        selectIcon: { color: "#fff" },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiAutocomplete-clearIndicator": { color: "rgba(255,255,255,0.7)" },
          "& .MuiAutocomplete-popupIndicator": { color: "rgba(255,255,255,0.7)" },
          "& .MuiAutocomplete-endAdornment button": { color: "rgba(255,255,255,0.7)" },
        },
        paper: { backgroundColor: "#2c2c2c" },
        option: { color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" } },
        noOptions: { color: "rgba(255,255,255,0.5)" },
      },
    },
  },
});

export default muiTheme;
